export default "__VITE_ASSET__PlHkVXPF__"